export default "__VITE_ASSET__ba77c23d__"